export const EMPTY_FIELD_VALUE = 'Не указано';
export const AUTOCOMPLETE_PLACEHOLDER = 'Выберите или введите для поиска';
